'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AvailSegments = require('./AvailSegments.jsx');

var _AvailSegments2 = _interopRequireDefault(_AvailSegments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailItinerary(props) {
  var journey = props.journey;

  var segments = journey;

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'AvailItinerary' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { padding: '0' } },
          _react2.default.createElement(_AvailSegments2.default, { segments: segments })
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(AvailItinerary);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailJourney.jsx
// module id = 1472
// module chunks = 0